export default {
  en: {
    // Legacy camelCase keys
    overtime: 'Overtime',
    schedule: 'Schedule',
    punch: 'Punch',
    timeAndAttendance: 'Time and Attendance',
    timeAndAttendanceAnalysis: 'Time and Attendance Analysis',
    crewSwing: 'Crew/Swing',
    laborSchedule: 'Labor Schedule',

    // All Hours
    'by-date': 'By Date',
    'sum-all-dates': 'Sum all Dates',
    'all-hours': 'All Hours',
    'fixed-sch-hrs': 'Fixed Sch Hrs',
    'scheduled-hours-for-schedule-symbols':
      "Scheduled hours for Schedule symbols that are 'fixed' (not dependent on sales volume)",
    'total-need-hrs': 'Total Need Hrs',
    'total-needed-hours':
      'Total Needed Hours - Variable Hours Needed plus Floor Hours Needed + Fixed Hours Scheduled',
    'act-gc-vs-proj': 'Act GC vs Proj',
    'actual-gc-minus-gc':
      'Actual GC minus GC that were projected in the scheduling software',
    'act-hrs': 'Act Hrs',
    'actual-hours-used':
      'Actual Hours used - Punched Hours plus Scheduled Salaried Hours',
    'act-hrs-vs-need': 'Act Hrs vs Need',
    'actual-hours-used-compared-to-hours-needed':
      'Actual hours used compared to hours needed (Needed Hours = Variable Needed + Fixed Sch Hrs + Flr Need Hrs)',
    'indicates-that-actual-hours-are-greater':
      'indicates that Actual Hours are greater than Needed Hours by 0.5 hours or more',
    'indicates-that-actual-hours-are-less':
      'indicates that Actual Hours are less than Needed Hours by 0.5 hours or more',
    'act-hrs-vs-sch': 'Act Hrs vs Sch',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Actual Hours used compared to Hours that were scheduled',
    'indicates-that-actual-hours-are-greater-than-scheduled-hours':
      'indicates that Actual Hours are greater than Scheduled Hours by 0.5 hours or more',
    'indicates-that-actual-hours-are-less-than-scheduled-hours':
      'indicates that Actual Hours are less than Scheduled Hours by 0.5 hours or more',
    'act-punch-hrs': 'Act Punch Hrs',
    'actual-hours-punched-on-the-time-clock':
      'Actual Hours punched on the time clock',
    'actual-gc': 'Actual GC',
    'actual-gc-recorded-by-the-pos': 'Actual GC recorded by the POS',
    'flr-need-hrs': 'Flr Need Hrs',
    'manager-hours-needed-to-run-the-floor':
      'Manager Hours needed to run the floor',
    'flr-sch-hrs': 'Flr Sch Hrs',
    'manager-hours-scheduled-to-run-the-floor':
      'Manager Hours Scheduled to run the floor',
    'projected-gc': 'Projected GC',
    'salaried-manager-hrs': 'Salaried Manager Hrs',
    'since-salaried-managers-do-not-punch-the-clock':
      'Since Salaried managers do not punch the clock, Scheduled Salaried Manager hours are used (it is assumed that all scheduled salaried hours get worked)',
    'sch-hrs': 'Sch Hrs',
    'scheduled-hours': 'Scheduled Hours',
    'sched-vs-guide': 'Sched vs Guide',
    'scheduled-hours-compared-to-projected-need':
      'Scheduled Hours compared to Projected Need',
    'indicates-that-scheduled-hours-are-greater-than-projected-need-by-0-5-hours-or-more':
      'indicates that Scheduled Hours are greater than Projected Need by 0.5 hours or more',
    'indicates-that-scheduled-hours-are-less-than-projected-need-by-0-5-hours-or-more':
      'indicates that Scheduled Hours are less than Projected Need by 0.5 hours or more',
    'proj-eff': 'Proj Eff',
    'was-the-number-of-hours-where-actual-gc':
      'Was the number of hours where Actual GC was within 10 of Projected GC, divided by total hours the restaurant was open (Yes/No)',
    'vlh-sched-hrs': 'VLH Sched Hrs',
    'sum-of-all-scheduled-variable-labor-hours':
      'Sum of all Scheduled Variable Labor Hours',
    'end-time': 'End Time',

    // Fixed Hours vs Guide
    'fixed-hours-schedule-vs-guide': 'Fixed Hours Schedule vs Guide',
    'fixed-guide': 'Fixed Guide',
    'hours-in-the-fixed-hours-guide':
      'Hours in the Fixed Hours guide (also called a contract) for a given scheduling symbol',
    'sched-vs-contract': 'Sched vs Contract',
    'sched-time-minus-fixed-guide': 'Sched Time minus Fixed Guide',
    'sched-time': 'Sched Time',
    'hours-scheduled-for-a-given-fixed-symbol':
      'Hours scheduled for a given fixed symbol',
    'symbol-description': 'Symbol Description',
    'extended-description-of-labor-scheduling-symbols':
      'Extended description of Labor Scheduling Symbols',
    symbol: 'Symbol',
    'one-or-two-letter-scheduling-symbols':
      'One or Two-letter scheduling symbols',

    // Labor Analysis Summary
    'labor-schedule': 'Labor Schedule',
    'schedule-type': 'Schedule Type',
    description: 'Description',
    'analysis-summary': 'Analysis Summary',
    'symbol-over-unders': 'Symbol Over/Unders',
    'planned-hours': 'Planned Hours',
    hours: '+/- Hours',
    'symbol-over-under-chart': 'Symbol Over/Under Chart',

    // Labor Schedules
    'labor-schedules': 'Labor Schedules',
    'labor-schedules-stats': 'Labor Schedules Stats',
    hour: 'Hour',

    // Labor Analysis
    'labor-analysis': 'Labor Analysis',
    'fixed-sched-flr-need': 'Fixed Sched + Flr Need',
    'fixed-sched-flr-sched': 'Fixed Sched + Flr Sched',
    'fixed-contract-flr-needed': 'Fixed Contract + Flr Needed',

    // Labor Statistics
    'labor-statistics': 'Labor Statistics',
    'we-have-adjusted-this-report':
      'We have adjusted this report to be aligned with your DAR reporting.',
    'fields-that-are-not-available':
      'Fields that are not available at the quarter hour level have been removed for data clarity.',
    'you-will-still-be-able': 'You will still be able to find these on the',
    'labor-analysis-report': 'Labor Analysis report',
    labor: 'Labor',
    sales: 'Sales',
    projected: 'Projected',
    'labor-statistics-analysis': 'Labor Statistics Analysis',

    // Schedule Variance
    'schedule-variance': 'Schedule Variance',
    'location-summary': 'Location Summary',
    'location-detail': 'Location Detail',

    // VLH Over/Under
    'vlh-over-under': 'VLH Over/Under',
    'projected-orders': 'Projected Orders',
    'projected-labor': 'Projected Labor',
    'over-under': 'Over/Under',
    // laborSchedulesChart
    chart: 'Chart',
    'sort-by-shift-start': 'Sort by Shift Start',
    'sort-by-shift-type': 'Sort by Shift Type',
    'chart-legend': 'Chart Legend',
    color: 'Color',
    close: 'Close',
    floor: 'Floor',
    'floor-guest-services': 'Floor Guest Services',
    'floor-production': 'Floor Production',
    'beverage-specialist': 'Beverage Specialist',
    'grill-regular-menu': 'Grill Regular Menu',
    'grill-breakfast-menu': 'Grill Breakfast Menu',
    'french-fry': 'French Fry',
    hashbrown: 'Hashbrown',
    window: 'Window',
    'administration/cash': 'Administration/Cash',
    'birthday-parties': 'Birthday Parties',
    closing: 'Closing',
    'food-safety': 'Food Safety',
    hiring: 'Hiring',
    'individual-development': 'Individual Development',
    lobby: 'Lobby',
    maintenance: 'Maintenance',
    'manager-meeting': 'Manager Meeting',
    opening: 'Opening',
    'planned-maintenance': 'Planned Maintenance',
    'pre-shift': 'Pre-Shift',
    schedules: 'Schedules',
    stat: 'Stat',
    'support/prep': 'Support/Prep',
    training: 'Training',
    transition: 'Transition',
    'truck-delivery': 'Truck Delivery',
    vat: 'Vat',
    'walk-thru': 'Walk Thru',
    'operations-technology-person': 'OTP (Operations Technology Person)',
    'guest-experience-lead': 'Guest Experience Lead',
    'general-manager': 'General Manager',
    'meal-break-unpaid': 'Meal Break (Unpaid)',
    'meal-break-paid': 'Meal Break (Paid)',
    'rest-break-paid': 'Rest Break (Paid)',
    'lactation-break-unpaid': 'Lactation Break (Unpaid)',
    'lactation-break-paid': 'Lactation Break (Paid)',
    name: 'Name',
    'shift-start': 'Shift Start',
    'shift-end': 'Shift End',

    // Employee Roster & Time Punches reports
    'employee-roster': 'Employee Roster',
    'time-punches': 'Time Punches',
    'employee-punches': 'Employee Punches',
    'date-s': 'Date(s)',
    'location-type': 'Location Type',
    'employment-status': 'Employment Status',
    employees: 'Employees',
    corporate: 'Corporate',
    franchise: 'Franchise',
    active: 'Active',
    terminated: 'Terminated',
  },
  es: {
    overtime: 'Tiempo Extra',
    schedule: 'Horario',
    punch: 'Registro',
    timeAndAttendance: 'Tiempo y Asistencia',
    timeAndAttendanceAnalysis: 'Análisis de Tiempo y Asistencia',
    crewSwing: 'Tripulación/Rotación',
    laborSchedule: 'Horario Laboral',

    'by-date': 'Por Fecha',
    'sum-all-dates': 'Sumar Todas las Fechas',
    'all-hours': 'Todas las Horas',
    'fixed-sch-hrs': 'Horas Programadas Fijas',
    'scheduled-hours-for-schedule-symbols':
      "Horas programadas para los simbolos de programacion que son 'fijos' (no dependen del volumen de ventas)",
    'total-need-hrs': 'Total Necesidad Hrs',
    'total-needed-hours':
      'Horas Totales Necesarias - Horas Variables Necesarias mas Horas Necesarias de Piso + Horas Programadas Fijas',
    'act-gc-vs-proj': 'GC Actual vs Proyectadas',
    'actual-gc-minus-gc':
      'GC Real menos GC que se proyectaron en el software de programacion',
    'act-hrs': 'Horas Actuales',
    'actual-hours-used':
      'Horas reales utilizadas - Horas marcadas mas horas programadas de gerente asalariado',
    'act-hrs-vs-need': 'Horas Actuales vs Necesidad',
    'actual-hours-used-compared-to-hours-needed':
      'Horas reales utilizadas en comparacion con las horas necesarias (Horas necesarias = Necesidad variable + Horas programadas fijas + Horas necesarias de piso)',
    'indicates-that-actual-hours-are-greater':
      'indica que las horas reales son mayores que las horas necesarias en 0.5 horas o mas',
    'indicates-that-actual-hours-are-less':
      'indica que las horas reales son menores que las horas necesarias en 0.5 horas o mas',
    'act-hrs-vs-sch': 'Horas Actuales vs Programadas',
    'actual-hours-used-compared-to-hours-that-were-scheduled':
      'Horas reales utilizadas en comparacion con las horas que se programaron',
    'indicates-that-actual-hours-are-greater-than-scheduled-hours':
      'indica que las horas reales son mayores que las horas programadas en 0.5 horas o mas',
    'indicates-that-actual-hours-are-less-than-scheduled-hours':
      'Indica que las horas reales son menores que las horas programadas en 0,5 horas o mas',
    'act-punch-hrs': 'Horas Fichadas',
    'actual-hours-punched-on-the-time-clock':
      'Horas reales marcadas en el reloj',
    'actual-gc': 'GC Real',
    'actual-gc-recorded-by-the-pos': 'GC Real registrado por el POS',
    'flr-need-hrs': 'Hrs Necesarias de Piso',
    'manager-hours-needed-to-run-the-floor':
      'Horas de gerente necesarias para ejecutar el piso',
    'flr-sch-hrs': 'Horas Programadas de Piso',
    'manager-hours-scheduled-to-run-the-floor':
      'Horas de gerente programadas para ejecutar el piso',
    'projected-gc': 'GC Proyectado',
    'salaried-manager-hrs': 'Horas de Gerente Asalariado',
    'since-salaried-managers-do-not-punch-the-clock':
      'Dado que los gerentes asalariados no marcan el reloj, se utilizan las horas programadas de gerente asalariado (se asume que todas las horas programadas de gerente asalariado se trabajan)',
    'sch-hrs': 'Horas Programadas',
    'scheduled-hours': 'Horas Programadas',
    'sched-vs-guide': 'Programa vs Guia',
    'scheduled-hours-compared-to-projected-need':
      'Horas programadas en comparacion con la necesidad proyectada',
    'indicates-that-scheduled-hours-are-greater-than-projected-need-by-0-5-hours-or-more':
      'indica que las horas programadas son mayores que la necesidad proyectada en 0.5 horas o mas',
    'indicates-that-scheduled-hours-are-less-than-projected-need-by-0-5-hours-or-more':
      'indica que las horas programadas son menores que la necesidad proyectada en 0.5 horas o mas',
    'proj-eff': 'Eficiencia Proyectada',
    'was-the-number-of-hours-where-actual-gc':
      'Fue el numero de horas en las que el GC real estuvo dentro de 10 del GC proyectado, dividido por el total de horas que el restaurante estuvo abierto (Si/No)',
    'vlh-sched-hrs': 'VLH Hora Programadas',
    'sum-of-all-scheduled-variable-labor-hours':
      'Suma de todas las horas de trabajo variable programadas',
    'end-time': 'Hora de Finalizacion',

    'fixed-hours-schedule-vs-guide': 'Horas Fijas Programadas vs Guia',
    'fixed-guide': 'Guia Fija',
    'hours-in-the-fixed-hours-guide':
      'Horas en la guia de horas fijas (tambien llamada contrato) para un simbolo de programacion dado',
    'sched-vs-contract': 'Programado vs contrato',
    'sched-time-minus-fixed-guide': 'Tiempo Programado menos Guia Fija',
    'sched-time': 'Tiempo Programado',
    'hours-scheduled-for-a-given-fixed-symbol':
      'Horas programadas para un simbolo fijo dado',
    'symbol-description': 'Descripcion del Simbolo',
    'extended-description-of-labor-scheduling-symbols':
      'Descripcion extendida de los simbolos de programacion de mano de obra',
    symbol: 'Simbolo',
    'one-or-two-letter-scheduling-symbols':
      'Simbolos de programacion de una o dos letras',

    'labor-schedule': 'Horario de Trabajo',
    'schedule-type': 'Tipo de Horario',
    description: 'Descripcion',
    'analysis-summary': 'Resumen del Analisis',
    'symbol-over-unders': 'Simbolo de Mas/Menos',
    'planned-hours': 'Horas Planificadas',
    hours: '+/- Horas',
    'symbol-over-under-chart': 'Grafico de Simbolos de Sobrantes y Faltantes',

    'labor-schedules': 'Horarios de Trabajo',
    'labor-schedules-stats': 'Estadisticas de Horarios de Trabajo',
    hour: 'Hora',

    'labor-analysis': 'Analisis de Mano de Obra',
    'fixed-sched-flr-need': 'Programacion Fija + Necesidad de Piso',
    'fixed-sched-flr-sched': 'Programacion Fija + Programacion de Piso',
    'fixed-contract-flr-needed': 'Contrato Fijo + Necesidad de Piso',

    'labor-statistics': 'Estadisticas de Mano de Obra',
    'we-have-adjusted-this-report':
      'Hemos ajustado este informe para que se alinee con su informe DAR.',
    'fields-that-are-not-available':
      'Los campos que no estan disponibles a nivel de cuarto de hora se han eliminado para mayor claridad de los datos.',
    'you-will-still-be-able': 'Aun podra encontrarlos en el',
    'labor-analysis-report': 'Informe de Analisis de Mano de Obra',
    labor: 'Mano de Obra',
    sales: 'Ventas',
    projected: 'Proyectado',
    'labor-statistics-analysis': 'Analisis de Estadisticas de Mano de Obra',

    'schedule-variance': 'Variacion de Horario',
    'location-summary': 'Resumen de Ubicacion',
    'location-detail': 'Detalle de Ubicacion',

    'vlh-over-under': 'VLH Mas/Menos',
    'projected-orders': 'Pedidos Proyectados',
    'projected-labor': 'Labor Proyectado',
    'over-under': 'Mas/Menos',
    // laborSchedulesChart
    chart: 'Gráfico',
    'sort-by-shift-start': 'Ordenar por Inicio de Turno',
    'sort-by-shift-type': 'Ordenar por Tipo de Turno',
    'chart-legend': 'Leyenda del Gráfico',
    color: 'Color',
    close: 'Cerrar',
    floor: 'Piso',
    'floor-guest-services': 'Piso de Servicios al Huésped',
    'floor-production': 'Piso de Producción',
    'beverage-specialist': 'Especialista en Bebidas',
    'grill-regular-menu': 'Parrilla Menú Regular',
    'grill-breakfast-menu': 'Parrilla Menú de Desayuno',
    'french-fry': 'Papas Fritas',
    hashbrown: 'Papas Ralladas',
    window: 'Ventana',
    'administration/cash': 'Administración/Caja',
    'birthday-parties': 'Fiestas de Cumpleaños',
    closing: 'Cierre',
    'food-safety': 'Seguridad Alimentaria',
    hiring: 'Contratación',
    'individual-development': 'Desarrollo Individual',
    lobby: 'Vestíbulo',
    maintenance: 'Mantenimiento',
    'manager-meeting': 'Reunión de Gerentes',
    opening: 'Apertura',
    'planned-maintenance': 'Mantenimiento Programado',
    'pre-shift': 'Pre-Turno',
    schedules: 'Horarios',
    stat: 'Estadística',
    'support/prep': 'Apoyo/Preparación',
    training: 'Entrenamiento',
    transition: 'Transición',
    'truck-delivery': 'Entrega de Camión',
    vat: 'Tina',
    'walk-thru': 'Inspección',
    'operations-technology-person':
      'PTO (Persona de Tecnología de Operaciones)',
    'guest-experience-lead': 'Líder de Experiencia del Cliente',
    'general-manager': 'Gerente General',
    'meal-break-unpaid': 'Descanso de Comida (No Pagado)',
    'meal-break-paid': 'Descanso de Comida (Pagado)',
    'rest-break-paid': 'Descanso (Pagado)',
    'lactation-break-unpaid': 'Descanso de Lactancia (No Pagado)',
    'lactation-break-paid': 'Descanso de Lactancia (Pagado)',
    name: 'Nombre',
    'shift-start': 'Inicio de Turno',
    'shift-end': 'Fin de Turno',

    // Employee Roster & Time Punches reports
    'employee-roster': 'Lista de Empleados',
    'time-punches': 'Registros de Tiempo',
    'employee-punches': 'Registros de Empleados',
    'date-s': 'Fecha(s)',
    'location-type': 'Tipo de Ubicación',
    'employment-status': 'Estado de Empleo',
    employees: 'Empleados',
    corporate: 'Corporativo',
    franchise: 'Franquicia',
    active: 'Activo',
    terminated: 'Terminado',
  },
};
